import { request } from 'tools'

export const getCompany = id => request.get( `corporate/companies/${id}` )
export const getWallets = () => request.get( 'corporate/wallets' )
export const getDomains = company => request.get( 'corporate/domains', { company } )
export const getTags    = company => request.get( 'tags', { company } )